import { AlertDialog } from "@hamlak/ui";
import { t } from "@/i18n/ko";

/** F01-08(시안 444:3866). neutral single. 확인 → 세션 폐기 → 비회원 홈(호출부). 오버레이 탭도 확인과 같다. */
export function UnderAgeDialog({ open, onConfirm }: { open: boolean; onConfirm: () => void }) {
  return (
    <AlertDialog
      open={open}
      tone="neutral"
      action="single"
      title={t("underAge.title")}
      description={t("underAge.body")}
      primaryLabel={t("underAge.cta")}
      onPrimary={onConfirm}
      onDismiss={onConfirm}
    />
  );
}
